<template><svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M30 13v15H0V13h30zm-2 3H16v3h12v-3zm2-13v9H0V3h30zm-2 3H16v3h12V6z" fill="currentColor" />
</svg>
</template>